<template>
    <div>
      <trademark-application-type-list></trademark-application-type-list>
    </div>
  </template>
  <script>
  export default {
  }
  </script>
  